function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function updateHeaderCartIcons(html) {
  if (html == null || html === '') return;

  document.querySelectorAll('.header__icon--cart').forEach((icon) => {
    icon.innerHTML = html;
  });
}

window.updateHeaderCartIcons = updateHeaderCartIcons;

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      if (element.id) element.id = `${element.id}-${uniqueKey}`;
      const formId = element.getAttribute('form');
      if (formId) element.setAttribute('form', `${formId}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.input.setAttribute('readonly', 'readonly');
    this.input.setAttribute('inputmode', 'none');
    this.input.setAttribute('aria-readonly', 'true');
    this.input.addEventListener('keydown', (e) => e.preventDefault());
    this.input.addEventListener('paste', (e) => e.preventDefault());
    this.input.addEventListener('drop', (e) => e.preventDefault());
    this.input.addEventListener('wheel', (e) => e.preventDefault(), { passive: false });
  }

  quantityUpdateUnsubscriber = undefined;
  cartUpdateUnsubscriber = undefined;
  cartErrorUnsubscriber = undefined;
  unlockTimeoutId = undefined;
  isLocked = false;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.cartErrorUnsubscriber) {
      this.cartErrorUnsubscriber();
    }
    if (this.unlockTimeoutId) {
      clearTimeout(this.unlockTimeoutId);
      this.unlockTimeoutId = undefined;
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  isInCartContext() {
    return Boolean(this.closest('cart-items') || this.closest('cart-drawer-items') || this.closest('quick-order-list'));
  }

  lockControls() {
    this.isLocked = true;
    this.querySelectorAll('button').forEach((btn) => {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
    });

    if (!this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
        if (evt?.source === 'cart-items') this.unlockControls();
      });
    }
    if (!this.cartErrorUnsubscriber) {
      this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => this.unlockControls());
    }
    if (this.unlockTimeoutId) clearTimeout(this.unlockTimeoutId);
    this.unlockTimeoutId = setTimeout(() => this.unlockControls(), 2000);
  }

  unlockControls() {
    this.isLocked = false;
    this.querySelectorAll('button').forEach((btn) => {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
    });
    if (this.unlockTimeoutId) {
      clearTimeout(this.unlockTimeoutId);
      this.unlockTimeoutId = undefined;
    }
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.isLocked) return;

    const previousValue = parseInt(this.input.value) || 0;
    const minValue = parseInt(this.input.min) || 0;
    const stepValue = parseInt(this.input.step) || 1;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      if (previousValue <= stepValue) {
        this.input.value = 0;
      } else {
        this.input.stepDown();
      }
    }

    const newValue = parseInt(this.input.value) || 0;

    if (previousValue !== newValue) {
      this.input.dispatchEvent(this.changeEvent);
      if (this.isInCartContext()) this.lockControls();
    }

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = minValue;
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.bindEvents();
    this.observeProductListWrapperOpen();
  }

  syncCollectionProductsScroll() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    this.querySelectorAll('.menu-drawer__collection-products').forEach((container) => {
      const directCards = container.querySelectorAll(':scope > .card-wrapper');
      const cards = directCards.length ? Array.from(directCards) : Array.from(container.querySelectorAll('.card-wrapper'));
      const cardsCount = cards.length;
      cards.forEach((card, idx) => {
        const isOdd = idx % 2 === 0; // 1st, 3rd, ...
        card.classList.toggle('menu-drawer__card-wrapper--odd', isOdd);
        card.classList.toggle('menu-drawer__card-wrapper--even', !isOdd);
      });

      const shopAllIsOdd = cardsCount % 2 === 0;
      const applyShopAllStripe = (el) => {
        if (!el) return;

        if (!isMobile) {
          el.classList.remove('menu-drawer__shop-all-row--odd', 'menu-drawer__shop-all-row--even');
          const link = el.querySelector?.('.menu-drawer__shop-all-link');
          link?.classList.remove('menu-drawer__shop-all-link--odd', 'menu-drawer__shop-all-link--even');
          return;
        }

        el.classList.remove('menu-drawer__shop-all-row--odd', 'menu-drawer__shop-all-row--even');
        el.classList.add(shopAllIsOdd ? 'menu-drawer__shop-all-row--odd' : 'menu-drawer__shop-all-row--even');

        const link = el.querySelector?.('.menu-drawer__shop-all-link');
        if (link) {
          link.classList.remove('menu-drawer__shop-all-link--odd', 'menu-drawer__shop-all-link--even');
          link.classList.add(shopAllIsOdd ? 'menu-drawer__shop-all-link--odd' : 'menu-drawer__shop-all-link--even');
        }
      };

      container.querySelectorAll(':scope > div').forEach((div) => {
        if (div.querySelector('.menu-drawer__shop-all-link')) applyShopAllStripe(div);
      });

      const shopAllSibling = container.nextElementSibling;
      if (shopAllSibling && shopAllSibling.querySelector?.('.menu-drawer__shop-all-link')) {
        applyShopAllStripe(shopAllSibling);
      }

      container.classList.toggle('menu-drawer__collection-products--scroll-y', isMobile && cardsCount > 7);
    });
  }

  syncProductListWrapperOpen() {
    const container = this.mainDetailsToggle;
    if (!container) return;

    container.querySelectorAll('details[data-leaf-open]').forEach((el) => el.removeAttribute('data-leaf-open'));
    const leafOpen = container.querySelector('details[open]:not(:has(details[open]))');
    if (leafOpen) leafOpen.setAttribute('data-leaf-open', '');

    container.querySelectorAll('.product-list-wrapper').forEach((el) => el.removeAttribute('data-open'));
    const openDetails = container.querySelector('details[open]:not(:has(details[open])):has(.product-list-wrapper)');
    if (openDetails) {
      const wrapper = openDetails.querySelector('.product-list-wrapper');
      if (wrapper) wrapper.setAttribute('data-open', '');
    }

    this.syncCollectionProductsScroll();
  }

  observeProductListWrapperOpen() {
    const container = this.mainDetailsToggle;
    if (!container) return;
    const observer = new MutationObserver(() => this.syncProductListWrapperOpen());
    observer.observe(container, { attributes: true, attributeFilter: ['open'] });
    container.querySelectorAll('details').forEach((d) => {
      observer.observe(d, { attributes: true, attributeFilter: ['open'] });
    });
    this.syncProductListWrapperOpen();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not([data-drawer-backdrop]):not([data-drawer-trigger])'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    const backdrop = this.querySelector('[data-drawer-backdrop]');
    if (backdrop) backdrop.addEventListener('click', (e) => this.closeMenuDrawer(e, this.mainDetailsToggle?.querySelector('summary')));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) {
        event.preventDefault();
        this.closeMenuDrawer(event, summaryElement);
        return;
      }

      event.preventDefault();
      this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
      return;
    } else {
      event.preventDefault();

      if (isOpen) {
        this.closeSubmenu(detailsElement);
        return;
      }

      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }

      const menuList = detailsElement.closest('ul.menu-drawer__menu, ul.list-menu');
      if (menuList) {
        menuList.querySelectorAll('li > details[open]').forEach((d) => {
          if (d !== detailsElement) {
            this.closeSiblingDetails(d);
          }
        });
      }
      detailsElement.querySelectorAll('details[open]').forEach((d) => this.closeSiblingDetails(d));

      detailsElement.setAttribute('open', '');
      requestAnimationFrame(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        this.syncProductListWrapperOpen();
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus, { once: true });
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    this.enableOutsideClickClose();
  }

  enableOutsideClickClose() {
    setTimeout(() => {
      document.addEventListener('pointerdown', this.onDocumentPointerDown, true);
    }, 0);
  }

  disableOutsideClickClose() {
    document.removeEventListener('pointerdown', this.onDocumentPointerDown, true);
  }

  onDocumentPointerDown(event) {
    if (!this.mainDetailsToggle?.hasAttribute('open')) return;

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary && (summary === event.target || summary.contains(event.target))) return;
    const drawer = this.mainDetailsToggle.querySelector('.menu-drawer');
    if (drawer && (drawer === event.target || drawer.contains(event.target))) return;
    if (event.target.closest('[data-header-search-focus]') || event.target.closest('.header__icon--search')) return;

    this.closeMenuDrawer(event, summary);
  }

  closeMenuDrawer(event = null, elementToFocus = this.mainDetailsToggle?.querySelector('summary'), extraOnClosed) {
    if (!this.mainDetailsToggle || !this.mainDetailsToggle.hasAttribute('open')) return;
    if (this.mainDetailsToggle.classList.contains('menu-closing')) return;

    this.disableOutsideClickClose();

    this.mainDetailsToggle.classList.add('menu-closing');
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      if (details !== this.mainDetailsToggle) details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.product-list-wrapper').forEach((el) => el.removeAttribute('data-open'));
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    removeTrapFocus(elementToFocus);
    const onAnimationClosed = () => {
      const menuSummary = this.mainDetailsToggle?.querySelector('summary');
      if (menuSummary) menuSummary.setAttribute('aria-expanded', 'false');
      this.mainDetailsToggle.querySelectorAll('details').forEach((d) => {
        if (d !== this.mainDetailsToggle) d.removeAttribute('open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      extraOnClosed && extraOnClosed();
    };
    this.closeAnimation(this.mainDetailsToggle, onAnimationClosed);
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (detailsElement === this.mainDetailsToggle) {
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      return;
    }
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.querySelectorAll('details[open]').forEach((d) => this.closeSiblingDetails(d));
    detailsElement.querySelectorAll('.submenu-open').forEach((el) => el.classList.remove('submenu-open'));
    detailsElement.querySelector('.product-list-wrapper')?.removeAttribute('data-open');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    detailsElement.classList.remove('menu-opening');
    this.closeAnimation(detailsElement);
  }

  closeSiblingDetails(detailsElement) {
    detailsElement.querySelectorAll('details[open]').forEach((d) => this.closeSiblingDetails(d));
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('.product-list-wrapper')?.removeAttribute('data-open');
    detailsElement.querySelector('summary')?.setAttribute('aria-expanded', false);
    detailsElement.removeAttribute('open');
  }

  closeAnimation(detailsElement, onComplete) {
    const drawer = detailsElement.querySelector('.menu-drawer');
    const submenu = detailsElement.querySelector('.menu-drawer__submenu');
    const isMainDrawer = !!drawer;
    const animatingEl = drawer || submenu;
    const DURATION_MS = isMainDrawer ? 450 : 260;
    const FALLBACK_MS = DURATION_MS + 80;
    let finished = false;

    const fallbackTimeout = setTimeout(() => {
      finishClose();
    }, FALLBACK_MS);

    const finishClose = () => {
      if (finished) return;
      finished = true;
      clearTimeout(fallbackTimeout);
      if (animatingEl) {
        animatingEl.removeEventListener('transitionend', onTransitionEnd);
      }
      if (drawer) {
        drawer.classList.add('menu-drawer--hiding');
        drawer.style.setProperty('display', 'none');
      }
      detailsElement.classList.remove('menu-closing');
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
      onComplete && onComplete();
    };

    const onTransitionEnd = (e) => {
      if (e.target !== animatingEl) return;
      var p = (e.propertyName || '').toLowerCase();
      if (drawer) {
        if (p !== 'transform' && p !== 'opacity' && p !== '') return;
      } else if (submenu) {
        if (p !== 'transform' && p !== '') return;
      }
      finishClose();
    };

    if (animatingEl) {
      animatingEl.addEventListener('transitionend', onTransitionEnd, { once: true });
    } else {
      finishClose();
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  bindEvents() {
    this.triggerButton = this.querySelector('[data-drawer-trigger]');
    if (this.triggerButton && !this.triggerBound) {
      this.triggerButton.addEventListener('click', this._onTriggerClick.bind(this));
      this.triggerBound = true;
    }
    this.bindDrawerEvents();
  }

  bindDrawerEvents() {
    if (!this.mainDetailsToggle || this.drawerEventsBound) return;
    super.bindEvents();
    this.observeProductListWrapperOpen();
    this.drawerEventsBound = true;
  }

  ensureDrawerInitialized() {
    if (this.mainDetailsToggle) {
      this.bindDrawerEvents();
      return true;
    }

    const template = this.querySelector('[data-drawer-template]');
    if (!template?.content) return false;

    this.appendChild(template.content.cloneNode(true));
    template.remove();
    this.mainDetailsToggle = this.querySelector('details');
    this.bindDrawerEvents();
    this.syncProductListWrapperOpen();
    return !!this.mainDetailsToggle;
  }

  _onTriggerClick(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    if (!this.ensureDrawerInitialized()) return;

    if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.classList.contains('menu-closing')) {
      this.closeMenuDrawer(null, this.triggerButton);
    } else if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.openMenuDrawer(this.triggerButton);
    }
  }

  openMenuDrawer(triggerElement) {
    if (!this.ensureDrawerInitialized()) return;

    if (this.triggerButton) this.triggerButton.setAttribute('aria-expanded', 'true');
    this.mainDetailsToggle.setAttribute('open', '');

    this.header = this.header || this.closest('.section-header') || document.querySelector('.section-header');
    const headerWrapper = this.closest('.header-wrapper');
    this.borderOffset = this.borderOffset || (headerWrapper && headerWrapper.classList.contains('header-wrapper--border-bottom') ? 1 : 0);
    const headerForPosition = headerWrapper || this.closest('sticky-header') || this.header;
    if (headerForPosition) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${Math.max(0, parseInt(headerForPosition.getBoundingClientRect().bottom - (this.borderOffset || 0), 10))}px`
      );
    }
    document.documentElement.style.setProperty('--viewport-height', `${this.getViewportHeightPx()}px`);
    if (this.header) this.header.classList.add('menu-open');

    const drawerEl = this.mainDetailsToggle.querySelector('.menu-drawer');
    if (drawerEl) {
      drawerEl.classList.remove('menu-drawer--hiding');
      drawerEl.style.removeProperty('display');
      // Force reflow so the browser registers the closed-state styles before adding menu-opening
      // eslint-disable-next-line no-unused-expressions
      drawerEl.offsetHeight;
    }
    this.mainDetailsToggle.classList.add('menu-opening');

    if (this.triggerButton) this.triggerButton.focus();
    window.addEventListener('resize', this.onResize);
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--drawer-scrollbar-width', scrollbarWidth ? `${scrollbarWidth}px` : '0');
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    this.enableOutsideClickClose();
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!this.mainDetailsToggle) return;

    elementToFocus = this.triggerButton || elementToFocus || this.mainDetailsToggle?.querySelector('summary');
    if (this.triggerButton) this.triggerButton.setAttribute('aria-expanded', 'false');
    const onClosed = () => {
      if (this.header) this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
      document.documentElement.style.removeProperty('--drawer-scrollbar-width');
      if (this.triggerButton) {
        requestAnimationFrame(() => { this.triggerButton.focus(); });
      }
    };
    super.closeMenuDrawer(event, elementToFocus, onClosed);
  }

  getViewportHeightPx() {
    if (typeof window.visualViewport !== 'undefined' && window.visualViewport.height > 0) {
      return Math.round(window.visualViewport.height);
    }
    return window.innerHeight;
  }

  // Drawer closes only via close button(s) or backdrop click — not on outside click (e.g. closing a message/toast)
  enableOutsideClickClose() {
    // Intentionally do nothing: avoid closing when overlays (messages, modals) are dismissed
  }

  onResize = () => {
    const headerForPosition = this.closest('.header-wrapper') || this.closest('sticky-header') || this.header;
    if (headerForPosition) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${Math.max(0, parseInt(headerForPosition.getBoundingClientRect().bottom - this.borderOffset, 10))}px`
      );
    }
    document.documentElement.style.setProperty('--viewport-height', `${this.getViewportHeightPx()}px`);
    this.syncCollectionProductsScroll();
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.max(1, Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    ));
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  getClosestSlideIndex() {
    if (!this.sliderItemsToShow || this.sliderItemsToShow.length === 0) return 0;
    const mid = this.slider.scrollLeft + this.slider.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    this.sliderItemsToShow.forEach((el, i) => {
      const c = el.offsetLeft + el.clientWidth / 2;
      const d = Math.abs(c - mid);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    });
    return best;
  }

  scrollToSlideIndex(index) {
    const slide = this.sliderItemsToShow[index];
    const slider = this.slider;
    const left = slide.offsetLeft + slide.clientWidth / 2 - slider.clientWidth / 2;
    const max = Math.max(0, slider.scrollWidth - slider.clientWidth);
    slider.scrollTo({ left: Math.max(0, Math.min(left, max)), behavior: 'smooth' });
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    if (!this.sliderItemsToShow || this.sliderItemsToShow.length < 2) return;

    const previousPage = this.currentPage;
    const slideIndex = this.getClosestSlideIndex();
    this.currentPage = slideIndex + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[slideIndex],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (slideIndex <= 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (slideIndex >= this.sliderItemsToShow.length - 1) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.sliderItemsToShow || this.sliderItemsToShow.length < 2) return;
    const idx = this.getClosestSlideIndex();
    const delta = event.currentTarget.name === 'next' ? 1 : -1;
    const targetIdx = Math.max(0, Math.min(this.sliderItemsToShow.length - 1, idx + delta));
    if (targetIdx === idx) return;
    this.scrollToSlideIndex(targetIdx);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener('change', this.onVariantChange);
    this.syncDependentOptions();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    const changedSelect = event.target?.closest?.('select') || event.target;
    if (changedSelect?.tagName === 'SELECT' && changedSelect.dataset.index === 'option1') {
      this.syncDependentOptions();
    }

    const target = this.getInputForEventTarget(event.target);
    this.updateSelectionMetadata(event);

    const selectedOptionValues = this.selectedOptionValues;
    const variant = this.getVariantFromSelectedOptions();

    this.syncUrlAndVariantInput(variant);

    publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: {
        event,
        target,
        selectedOptionValues,
        variant,
      },
    });
  }

  syncDependentOptions() {
    const option1Select = this.querySelector('select[data-index="option1"]');
    const option2Select = this.querySelector('select[data-index="option2"]');
    if (!option1Select || !option2Select) return;

    const variants = this.getVariantData();
    if (!variants.length) return;

    const option1Value = option1Select.value;
    const availableOption2Values = [
      ...new Set(
        variants
          .filter((variant) => variant.options?.[0] === option1Value)
          .map((variant) => variant.options?.[1])
          .filter(Boolean)
      ),
    ];
    if (!availableOption2Values.length) return;

    if (!option2Select._allOptions) {
      option2Select._allOptions = Array.from(option2Select.options).map((option) => option.cloneNode(true));
    }

    const currentOption2Value = option2Select.value;
    option2Select.innerHTML = '';

    availableOption2Values.forEach((optionValue) => {
      const source = option2Select._allOptions.find((option) => option.value === optionValue);
      const optionElement = source ? source.cloneNode(true) : document.createElement('option');
      if (!source) {
        optionElement.value = optionValue;
      }
      optionElement.textContent = optionValue;
      optionElement.removeAttribute('selected');
      option2Select.appendChild(optionElement);
    });

    const nextValue = availableOption2Values.includes(currentOption2Value)
      ? currentOption2Value
      : availableOption2Values[0];
    option2Select.value = nextValue;
    option2Select.selectedOptions[0]?.setAttribute('selected', 'selected');
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options).forEach((option) => {
        if (option.hasAttribute('selected')) option.removeAttribute('selected');
      });
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        ?.querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest('.product-form__input')?.querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    if (target.tagName === 'SELECT') {
      return target.selectedOptions[0] || target;
    }
    return target;
  }

  get selectedOptionValues() {
    const values = [];

    this.querySelectorAll('select, fieldset, input[type="hidden"][data-option-value-id]').forEach((element) => {
      if (element.tagName === 'SELECT') {
        const optionValueId = element.selectedOptions[0]?.dataset.optionValueId;
        if (optionValueId) values.push(optionValueId);
        return;
      }

      if (element.tagName === 'FIELDSET') {
        const optionValueId = element.querySelector('input:checked')?.dataset.optionValueId;
        if (optionValueId) values.push(optionValueId);
        return;
      }

      if (element.dataset.optionValueId) values.push(element.dataset.optionValueId);
    });

    return values;
  }

  getVariantFromSelectedOptions() {
    const variants = this.getVariantData();
    if (!variants.length) return null;

    const selectedValues = [];
    this.querySelectorAll('select, fieldset, input[type="hidden"][data-option-value-id]').forEach((element) => {
      if (element.tagName === 'SELECT') {
        if (element.value) selectedValues.push(element.value);
        return;
      }

      if (element.tagName === 'FIELDSET') {
        const checked = element.querySelector('input:checked');
        if (checked?.value) selectedValues.push(checked.value);
        return;
      }

      if (element.value) selectedValues.push(element.value);
    });

    return (
      variants.find((variant) => variant.options.every((option, index) => option === selectedValues[index])) || null
    );
  }

  getVariantData() {
    if (this.variantData) return this.variantData;

    const script = this.querySelector('[data-product-variants]');
    if (!script) {
      this.variantData = [];
      return this.variantData;
    }

    try {
      this.variantData = JSON.parse(script.textContent) || [];
    } catch (error) {
      console.error(error);
      this.variantData = [];
    }

    return this.variantData;
  }

  syncUrlAndVariantInput(variant) {
    if (!variant?.id) return;

    const productInfo = this.closest('product-info');
    const sectionId = this.dataset.section || productInfo?.dataset.section;
    const productUrl = productInfo?.dataset.url || window.location.pathname;

    document
      .querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}`)
      .forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = variant.id;
        input.removeAttribute('disabled');
      });

    if (productInfo?.dataset.updateUrl === 'false') return;

    const baseUrl = (productUrl || window.location.pathname).split('?')[0];
    window.history.replaceState({}, '', `${baseUrl}?variant=${variant.id}`);
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        const hasRecommendationItems = Boolean(html.querySelector('.grid__item'));

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!hasRecommendationItems && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (hasRecommendationItems) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}
